module.exports = __webpack_public_path__ + "static/media/443JamesPBrawleyNW_2018-06-12_83.9d8c6bc9.jpg";